export const TAG = 'ErrorPage';
